import React, { useContext, useState, useEffect } from 'react';
import { Paper } from '@mui/material';
import { Link } from 'react-router-dom';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { Button } from '@mui/material';
import { SchoolContex } from '../../Helper/Contex';
import api from '../../API/api';
import { useParams } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'

import { Helmet } from "react-helmet";

const htmlToFormattedText = require("html-to-formatted-text");

const SingleBlog = () => {
    const params = useParams();
    const navigate = useNavigate();

    const { schools, courses } = useContext(SchoolContex)

    const [blog, setBlogs] = useState();

    useEffect(() => {
        getBlogs()

    }, [])

    const getBlogs = () => {
        api.singleBlog(params.slug).then((res) => {
            // console.log(res);
            setBlogs(res.data.blogs)
        })
            .catch((err) => {
                // console.log(err.response);
            })
    }


    return (
        <>

            {blog &&
                <Helmet>
                    <meta charSet="utf-8" />
                    <title>{blog && blog.metaTitle}</title>
                    <meta name="description" content={blog && blog.metaDescription} />
                    <meta property="og:image" content={`${process.env.REACT_APP_BACKEND}blogs/thumb/${blog.thumb}`}></meta>

                </Helmet>
            }



            <div className='my-2'>
                <div className="row m-0 p-0">
                    <div className="col-md-8">
                        <Paper elevation={3}>
                            <div className='row p-3'>
                                {blog &&
                                    <>
                                        <div>
                                            <div className='text-center'>
                                                <h3>{blog.title}</h3>
                                            </div>
                                            <img src={`${process.env.REACT_APP_BACKEND}blogs/cover/${blog.cover}`} alt={blog.title} className='col-12' />
                                        </div>

                                        <div className='m-3 p-3'>
                                            <div dangerouslySetInnerHTML={{ __html: blog.details }} />
                                        </div>


                                    </>
                                }


                            </div>
                        </Paper>

                    </div>





                    <div className="col-md-4">
                        <Paper elevation={3}>
                            <div className='p-3'>
                                <div>
                                    <Button variant='contained' fullWidth>
                                        Our Schools
                                    </Button>

                                    {schools && schools.map((s) => (
                                        <div className='m-1'>
                                            <Button size='small' onClick={() => navigate(`/school/${s.slug}`)} variant='outlined'>
                                                {s.schoolName}
                                            </Button>
                                        </div>
                                    ))}
                                </div>
                                <div className='mt-5'>
                                    <Button variant='contained' fullWidth>
                                        Our Courses
                                    </Button>

                                    {courses && courses.map((s) => (
                                        <div className='m-1'>
                                            <Button size='small' onClick={() => navigate(`/course/${s.shortName}`)} variant='outlined'>
                                                {s.courseName}
                                            </Button>
                                        </div>
                                    ))}
                                </div>

                            </div>
                        </Paper>

                    </div>
                </div>

            </div>
        </>
    )
}

export default SingleBlog;